import {
  endOfMonth,
  endOfWeek,
  endOfYear,
  format,
  startOfMonth,
  startOfWeek,
  startOfYear,
  subMonths,
  subWeeks,
  subYears,
} from 'date-fns';

export type DateRangePresetId =
  | 'this_week'
  | 'last_week'
  | 'this_month'
  | 'last_month'
  | 'this_year'
  | 'last_year'
  | 'all_dates';

export type DateRangeValue = {
  from: string | null;
  to: string | null;
};

export const DATE_RANGE_PRESET_IDS: DateRangePresetId[] = [
  'this_week',
  'last_week',
  'this_month',
  'last_month',
  'this_year',
  'last_year',
  'all_dates',
];

function formatApiDate(value: Date | null): string | null {
  return value ? format(value, 'yyyy-MM-dd') : null;
}

export function getDateRangePresetValue(
  presetId: DateRangePresetId,
  today = new Date(),
): DateRangeValue {
  let from: Date | null;
  let to: Date | null;

  switch (presetId) {
    case 'this_week':
      from = startOfWeek(today, { weekStartsOn: 1 });
      to = endOfWeek(today, { weekStartsOn: 1 });
      break;
    case 'last_week': {
      const lastWeek = subWeeks(today, 1);
      from = startOfWeek(lastWeek, { weekStartsOn: 1 });
      to = endOfWeek(lastWeek, { weekStartsOn: 1 });
      break;
    }
    case 'this_month':
      from = startOfMonth(today);
      to = endOfMonth(today);
      break;
    case 'last_month': {
      const lastMonth = subMonths(today, 1);
      from = startOfMonth(lastMonth);
      to = endOfMonth(lastMonth);
      break;
    }
    case 'this_year':
      from = startOfYear(today);
      to = endOfYear(today);
      break;
    case 'last_year': {
      const lastYear = subYears(today, 1);
      from = startOfYear(lastYear);
      to = endOfYear(lastYear);
      break;
    }
    case 'all_dates':
      from = null;
      to = null;
      break;
  }

  return {
    from: formatApiDate(from),
    to: formatApiDate(to),
  };
}

export function isDateRangePresetActive(
  presetId: DateRangePresetId,
  value: DateRangeValue,
  today = new Date(),
): boolean {
  const presetValue = getDateRangePresetValue(presetId, today);
  return presetValue.from === value.from && presetValue.to === value.to;
}
